/**
 * Visual HMI Editor Domain Model
 */

export type HMIComponentType =
  | 'Text'
  | 'PushButton'
  | 'PilotLamp'
  | 'NumericDisplay'
  | 'LinearGauge'
  | 'TankLevel'
  | 'MotorStatus'
  | 'CoolingFan'
  | 'BarGraph'
  | 'AlarmBanner'
  | 'NavigationButton';

export interface HMIDataBinding {
  readonly type: 'PLC' | 'MODBUS' | 'ALARM' | 'NONE';
  readonly address: string; // e.g., 'Q0.0', 'IW2', 'M1.0'
  readonly scaleMin?: number;
  readonly scaleMax?: number;
}

export interface HMIComponent {
  readonly id: string;
  readonly type: HMIComponentType;
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
  readonly binding: HMIDataBinding;
  readonly props: Record<string, unknown>; // Component-specific props (e.g. label, color, targetScreen)
}

export interface HMIScreen {
  readonly id: string;
  readonly name: string;
  readonly width: number;
  readonly height: number;
  readonly backgroundColor: string;
  readonly components: readonly HMIComponent[];
}

export interface HMIProject {
  readonly screens: readonly HMIScreen[];
  readonly defaultScreenId: string | null;
}

export function createEmptyHMIProject(): HMIProject {
  const defaultScreen: HMIScreen = {
    id: `screen_${Date.now()}`,
    name: 'Screen 1',
    width: 800,
    height: 600,
    backgroundColor: '#ffffff',
    components: []
  };
  return {
    screens: [defaultScreen],
    defaultScreenId: defaultScreen.id
  };
}
